import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as MoreSvg } from '../../assets/more-icon.svg';

export const MoreIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={MoreSvg} {...props} />;
};
